<template>
  <div>
    <div
      id="uniquemodal"
      ref="instance"
      class="modal fade show"
      data-backdrop="false"
      tabindex="-1"
      role="dialog"
      style="z-index: 99999"
    >
      <div
        v-on:click="this.hideModal"
        style="height: 100%; width: 100%; position: fixed"
      ></div>
      <div
        :class="{
          'modal-fullscreen': fullScreen,
          'modal-dialog-centered': !isMobile(),
          'bt-25': isMobile(),
        }"
        :style="mdStyle"
        class="modal-dialog"
      >
        <div
          :class="{
            'bt-25': isMobile(),
          }"
          :style="mbStyle"
          class="modal-content"
        >
          <div>
            <slot name="close" />
          </div>
          <div
            :class="{ 'p-0': fullHeader }"
            class="modal-header"
            style="border: 0"
          >
            <slot name="header" />
          </div>
          <div class="modal-body" :style="bodyStyle">
            <slot name="body" />
          </div>
          <div
            v-if="!hideFooter"
            class="modal-footer flex-wrap justify-content-center sticky"
            :style="[borderless ? { border: 'none !important' } : '']"
          >
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { scrollModify } from "../api/helpers/uiHelper";
import { mapMutations, mapGetters } from "vuex";
export default {
  props: {
    fullHeader: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "500px",
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    canBeDismissed: {
      type: Boolean,
      required: false,
      default: true,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    topMargin: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["styles"]),
    bodyStyle() {
      return [];
    },
    mdStyle() {
      let styles = [];
      styles.push({ "max-width": this.width });
      if (this.isMobile()) {
        styles.push(this.styles.pageColor);
        if (this.topMargin.length) {
          styles.push({ "margin-top": this.topMargin });
        }
      }
      return styles;
    },
    mbStyle() {
      let styles = [];
      if (this.isMobile()) {
        styles.push(this.styles.pageColor);
        if (this.fullScreen) {
          styles.push({ "margin-top": "0px !important", height: "100%" });
        }
      }
      return styles;
    },
  },
  created() {
    this.$nextTick(() => {
      let that = this;
      $(this.$refs.instance).modal("show");

      $(this.$refs.instance).on("hidden.bs.modal", function () {
        that.$emit("close");
        that.setActivePopupState(false);
        scrollModify(false);
      });
      $(this.$refs.instance).on("shown.bs.modal", function () {
        that.$emit("open");
        that.setActivePopupState(true);
        scrollModify(true);
      });
    });

    // this.$root.$on("show-order-type-modal", (flag) => {
    //   if (flag === false) {
    //     this.hideModal(true);
    //   }
    // });
  },
  methods: {
    ...mapMutations(["setActivePopupState"]),
    hideModal(forceHide = false) {
      const forceHideModal = typeof forceHide === "boolean" ? forceHide : false;
      if (this.canBeDismissed || forceHideModal) {
        if (this.$refs.instance) {
          $(this.$refs.instance).modal("hide");
        }
      }
    },
  },
};
</script>
